import React from "react";
import {addSeparator, notEmpty} from "core/common/utils/arrayUtils";
import {MdDivider} from "core/components/blockComp/blockComp";
import moment from "moment";
import Drawer from "material-ui/Drawer";
import {LoadingElement} from "core/components/common/loading";
import {screenSm} from "core/common/config/variables";
import DocumentComp from "core/document/component/documentComp";
import {OverlayTrigger, Tooltip, Popover} from "react-bootstrap";
import {lovLabel, lovValue} from "core/form/formUtils";
import {formatDateTime, formatInterval, isValid} from "core/common/utils/dateUtils";
import "core/event/component/historyBlocks.less";
import mdEntityService from "core/metamodel/mdEntityService";
import {
  EVENTCATEGORY, DMLOPERATION, EventHistory, EmailRecipient, bccEmailAddress, ccEmailAddress, PartyActivity,
  toEmailAddress, EntityStatus, EVENTCATEGORY_MAP, HistoryObject
} from "core/event/eventDomain";
import Form from "core/form/form";
import {SEVERITY} from "core/common/domain/commonDomain";
import {observer} from "mobx-react";
import {entityStatusCss, entityStatusText, validationMessageCss} from "core/common/page/dialogAncestor";
import * as icons from "core/components/buttons/svgIcons";
import {Link} from 'react-router';
import {addTenantToQuery} from "core/common/utils/utils";
import {loc} from "core/common/config/locales";
import MdEntity from "core/metamodel/mdEntity";
import {green500, grey400, orange700, red500} from "material-ui/styles/colors";




/* **************************************************************************************
 *******     EventHistoryDiff     *******************************************************
 ****************************************************************************************/

const __iconStyleAdd = {color: grey400, width: 22, height: 22};
const __iconStyleDelete = {color: grey400, width: 19, height: 19};

const nee = () => false;

const EventHistoryFieldDiffBlock = ({historyObject, entity}: {historyObject: HistoryObject, entity: MdEntity}) => (
  historyObject.fields && historyObject.fields.length ? (
    <table className="zz-simple-table">
      <thead>
      <tr>
        <th>{loc.i18n`Field`}</th>
        <th>{loc.i18n`Old value`}</th>
        <th>{loc.i18n`New value`}</th>
      </tr>
      </thead>
      <tbody>
      {historyObject.fields.map((field, index) => {
        let mdField = entity.getField(field.fieldName);
        return (
          <tr key={index}>
            <td>{mdField ? mdField.formLabelActive : field.fieldName}</td>
            <td>{mdField ? mdField.formatValue(field.oldValue) : field.oldValue}</td>
            <td>{mdField ? mdField.formatValue(field.newValue) : field.newValue}</td>
          </tr>
        )
      })}
      </tbody>
    </table>
  ) : null
);


const ErrorBlock = ({index, operationText, label, text}) => (
  <div className="eh-object" key={index}>
    <div className="eh-object-header">
      <span className="operation">{operationText}</span>
      <span className="text">{label}</span>
    </div>
    <div className="eh-object-full">
      <p>{text}</p>
    </div>
  </div>
)

export const EventHistoryBlock = ({eventHistory, entities}) => {

    let EventCatIcon = icons[EVENTCATEGORY_MAP[eventHistory.eventCategory].icon];

    return (
      <div className="event-history">
        <div className="eh-header">
          <div className="eh-header-left">
            <EventCatIcon/>
            <div className="text">{lovLabel(eventHistory.eventType)}</div>
          </div>
              <OverlayTrigger placement="bottom" delayShow={500} overlay={<Tooltip id={eventHistory.eventHistoryId + "_dateTooltip"}>{formatDateTime(eventHistory.dateCreated)}</Tooltip>}>
                <span>{eventHistory.userCreated}, {moment(eventHistory.dateCreated).fromNow()}</span>
              </OverlayTrigger>
        </div>

        {(eventHistory.message)? (
          <div className="eh-objects">
            {eventHistory.message}
          </div>
        ) : null}

        { (eventHistory.eventCategory === EVENTCATEGORY.DATA_EVENT && eventHistory.historyObjects.length) ?

          <div className="eh-objects">
            {addSeparator(eventHistory.historyObjects.map((historyObject, index) => {

              let entity = entities.get(historyObject.entityName);

              let operationText = (historyObject.operation === DMLOPERATION.INSERT) ? loc.i18n`ADDED`
                : ( (historyObject.operation === DMLOPERATION.DELETE) ? loc.i18n`DELETED` :
                loc.i18n`UPDATED` );

              if (!entity) {
                return <ErrorBlock text={"Entity " + historyObject.entityName + " does not exists in Entities map"} operationText={operationText} key={index} index={index} label={lovLabel(entity)}/>
              }


              // full render
              if ((historyObject.operation === DMLOPERATION.INSERT || historyObject.operation === DMLOPERATION.DELETE) && historyObject.fullObject) {
                let entityConfig = mdEntityService.getEntityConfig(historyObject.entityName);
                let formName = entityConfig.getFormName(historyObject);
                let ClosedContent = mdEntityService.getClosedContent(formName);
                if (!ClosedContent) {
                  return <ErrorBlock text={"ClosedContent for formName " + formName + " does not exists in CLOSED_CONTENT_REGISTRY"} operationText={operationText} key={index} index={index} label={lovLabel(entity)}/>
                }

                let formDefinition = mdEntityService.getFormDefinition(formName);
                if (!formDefinition) {
                  return <ErrorBlock text={"Form Definition for formName " + formName + " does not exists in FORM_DEFINITION_REGISTRY"} operationText={operationText} key={index} index={index} label={lovLabel(entity)}/>
                }

                let form: Form<any> = (historyObject.fullObject.getForm) ? historyObject.fullObject.getForm(formName) : new Form(formName, formDefinition);

                let fields = form.setupFields(historyObject.fullObject, historyObject.fullObject, entity, entities, null);

                return (
                  <div className="eh-object" key={index}>
                    <div className="eh-object-header">
                      <span className="operation">{operationText}</span>
                      <span className="text">{entity.label}</span>
                    </div>
                    <div className="eh-object-full">
                      {React.createElement(
                        ClosedContent,
                        {
                          dataObject: historyObject.fullObject,
                          rootObject: historyObject.fullObject,
                          entities,
                          entity,
                          fields,
                          key: index,
                          disabled: true
                        },
                        null
                      )}
                    </div>
                    <EventHistoryFieldDiffBlock entity={entity} historyObject={historyObject}/>
                  </div>
                );

              }

              // diff render
              return (
                <div className="eh-object" key={index}>
                  <div className="eh-object-header">
                    <span className="operation">{operationText}</span>
                    <span className="text">{`${entity.label} - ${historyObject.entityLabel}`}</span>
                  </div>
                  <EventHistoryFieldDiffBlock entity={entity} historyObject={historyObject}/>
                </div>
              )

            }), <MdDivider/>)}
          </div>
          : null}

        { (eventHistory.eventCategory === EVENTCATEGORY.DATA_EVENT && eventHistory.documents.length) ?
          <div className="eh-documents">
            <DocumentComp documents={eventHistory.documents} entities={entities} style={{flex: '1 1 auto'}}
                          enableUpload={false}
                          documentEntity={entities.get('Document')} canDeleteFn={nee}/>
          </div>
          : null }

        { (eventHistory.eventCategory === EVENTCATEGORY.EMAIL_EVENT) ? <EmailEventHistory eventHistory={eventHistory}/> : null }
        { (eventHistory.eventCategory === EVENTCATEGORY.SMS_EVENT) ? <SmsMessageEventHistory eventHistory={eventHistory}/> : null }
        { (eventHistory.eventCategory === EVENTCATEGORY.VIBER_EVENT) ? <ViberMessageEventHistory eventHistory={eventHistory}/> : null }

      </div>
    );
  }
  ;



export interface CustomHistoryBlockProps {
  icon: string;
  name: string;
  dateCreated: string|Date;
  userCreated: string;
  objectElement: React.ReactElement<any>;
}

export const CustomHistoryBlock = ({icon, name, dateCreated, userCreated, objectElement}: CustomHistoryBlockProps) => {

    let EventCatIcon = icons[icon];

    return (
      <div className="event-history">
        <div className="eh-header">
          <div className="eh-header-left">
            <EventCatIcon/>
            <div className="text">{name}</div>
          </div>
          <div>{userCreated}, { moment(dateCreated).fromNow()}</div>
        </div>

        <div className="eh-objects">
          <div className="eh-object">
            <div className="eh-object-full">
              {objectElement}
            </div>
          </div>
        </div>

      </div>
    );
  }
;


export const EmailHeader = ({emailFrom, emailRecipients}: {emailFrom: string, emailRecipients: EmailRecipient[]}) => {

  const to = toEmailAddress(emailRecipients);
  const cc = ccEmailAddress(emailRecipients);
  const bcc = bccEmailAddress(emailRecipients);


  return (
  <table className="eh-email-table">
    <tbody>
    <tr>
      <td>From: </td>
      <td>{emailFrom}</td>
    </tr>

    { (to.length) ?  <tr>
      <td>To</td>
      <td> {to.join(", ")} </td>
    </tr> : null}
    { (cc.length) ?  <tr>
      <td>Cc</td>
      <td> {cc.join(", ")} </td>
    </tr> : null}
    { (bcc.length) ?  <tr>
      <td>Bcc</td>
      <td> {bcc.join(", ")} </td>
    </tr> : null}
    </tbody>
  </table>
)};

export const EmailEventHistory = ({eventHistory}: { eventHistory: EventHistory | PartyActivity }) => {
  return (
    <div className="eh-email">
      <h5>{eventHistory.emailSubject}</h5>
      <EmailHeader emailFrom={eventHistory.emailFrom} emailRecipients={eventHistory.emailRecipients}/>
      <div dangerouslySetInnerHTML={{__html: eventHistory.emailBody}}/>
    </div>
  )
};


export const SmsMessageEventHistory = ({eventHistory}: { eventHistory: EventHistory}) => {
  return (
    <div className="eh-email">
      <div className="eh-object-header">
        <span className="operation">Phone Number</span>
        <span className="text">{eventHistory.smsMessage.toNumber}</span>
      </div>
      <div className="eh-object-header">
        <span className="operation">Message</span>
        <span className="text">{lovLabel(eventHistory.smsMessage.smsText)}</span>
      </div>
      {(!eventHistory.smsMessage.success) ? (
        <div className="eh-object-header">
          <span className="operation">Error</span>
          <span className="text" style={{color: red500}} >{eventHistory.smsMessage.errorDescription}</span>
        </div>

      ) : null}
      {(eventHistory.smsMessage.deliverySuccess === true) ? (
        <div className="eh-object-header">
          <span className="text" style={{color: green500}}>Delivered on {formatDateTime(eventHistory.smsMessage.deliveryTime)}</span>
        </div>
      ) : null}
      {(eventHistory.smsMessage.deliverySuccess === false) ? (
        <div className="eh-object-header">
          <span className="text" style={{color: orange700}}>Delivery Failed confirmation on {formatDateTime(eventHistory.smsMessage.deliveryTime)}</span>
        </div>
      ) : null}
    </div>
  )
};

export const ViberMessageEventHistory = ({eventHistory}: { eventHistory: EventHistory}) => {
  return (
    <div className="eh-email">
      <div className="eh-object-header">
        <span className="operation">Viber user id</span>
        <span className="text">{eventHistory.viberMessage.toUserId}</span>
      </div>
      <div className="eh-object-header">
        <span className="operation">Message</span>
        <span className="text">{lovLabel(eventHistory.viberMessage.messageText)}</span>
      </div>
      {(eventHistory.viberMessage.errorDescription) ? (
        <div className="eh-object-header">
          <span className="operation">Error</span>
          <span className="text" style={{color: red500}} >{eventHistory.viberMessage.errorDescription}</span>
        </div>

      ) : null}
      {(eventHistory.viberMessage.deliverySuccess === true) ? (
        <div className="eh-object-header">
          <span className="text" style={{color: green500}}>Delivered on {formatDateTime(eventHistory.viberMessage.dateUpdated)}</span>
        </div>
      ) : null}
      {(eventHistory.viberMessage.deliverySuccess === false) ? (
        <div className="eh-object-header">
          <span className="text" style={{color: orange700}}>Delivery Failed confirmation</span>
        </div>
      ) : null}
    </div>
  )
};



export const EventHistoryDrawer = ({eventHistories, entities, open, loading, onRequestChange}) => {

  let screenWidth = document.body.getBoundingClientRect().width;

  return (
    <Drawer openSecondary open={open}
            width={ ((screenWidth < screenSm) ? 0.9 : 0.6) * screenWidth }
            docked={false}
            onRequestChange={onRequestChange}
            containerStyle={{paddingTop: 40}}
    >
      { (loading) ? <LoadingElement/> : null}
      {
        (eventHistories && eventHistories.length) ?
          addSeparator(eventHistories.map((eventHistory, index) => (
            <EventHistoryBlock eventHistory={eventHistory} entities={entities} key={index}/>
          )), <MdDivider inset/>) : null
      }
    </Drawer>
  )
};

export const PartyActivityTable = observer( ({statuses, showErrors}: {statuses: EntityStatus[], showErrors: boolean}) => (
  <table className="table table-condensed fullwrap">
    <tbody>
    {statuses.filter( es => showErrors || es.status !== SEVERITY.ERROR ).map( (es, index) => {
      let _className = entityStatusCss(es);
      return (
        <tr key={index}>
          <td className={_className}>
            { (es.partyActivity && notEmpty(es.partyActivity.objects)) ? (
              <div>
                {es.partyActivity.objects.map( (pao, index) => <div key={index} style={{marginLeft: 10}}>{lovLabel(pao.fullObject)}</div>)}
              </div>
            ) : null}
            { (es.partyActivity) ? <div>Customer:
              <Link to="partyDetail" params={{id: lovValue(es.partyActivity.customer)}}  query={addTenantToQuery()}><span className={_className}>{lovLabel(es.partyActivity.customer)}</span></Link>
              </div> : null}
            { (es.partyActivity && notEmpty(es.partyActivity.persons)) ? (
              <div>
                <span>Persons</span>
                {es.partyActivity.persons.map( (person, index) => <div key={index} style={{marginLeft: 10}}>
                  <Link to="partyDetail" params={{id: lovValue(person)}}  query={addTenantToQuery()}><span className={_className}>{lovLabel(person)}</span></Link>
                  </div>)}
              </div>
            ) : null}

            { (notEmpty(es.messages)) ? (
              <table style={{marginLeft: 20}}>
                <tbody>
                {es.messages.map( (messageObj, index) => (
                  <tr key={index}><td className={validationMessageCss(messageObj)}>{messageObj.message}</td></tr>
                ))}
                </tbody>
              </table>
            ) : null}
          </td>
          <td className={_className}>
            { (es.partyActivity) ? <EmailHeader emailFrom={es.partyActivity.emailFrom} emailRecipients={es.partyActivity.emailRecipients}/> : null}
          </td>
          <td className={_className}>
            {entityStatusText(es)}
          </td>
        </tr>
      )
    })}
    </tbody>
  </table>
));



// WEBPACK FOOTER //
// ./src/core/event/component/historyBlocks.tsx